export default function NotFound() {
  return (
    <div
      className="min-h-screen bg-[#0a0a0a] text-neutral-500 flex items-center justify-center px-6"
      data-testid="not-found-page"
    >
      <div className="text-center">
        <div className="text-6xl font-display font-bold text-neutral-700">404</div>
        <div className="mt-3 text-sm tracking-widest uppercase text-neutral-500">
          Page not found
        </div>
      </div>
    </div>
  );
}
